import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { TcsmStates } from '../../root/tcsm-model';
import { GenerateAdminQuickNavMenu } from '../constants/navigation-lists';
import { EmployeeContext } from '../models/app-context-model';
import { DropdownNavigation } from './dropdown-navigation';
import { roleObjectMatch } from '../helpers/auth-helpers';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { useRoleObject } from '../../pages/arc/components/useRoles';

export interface Props {
	basePath: string;
}

export const AdminNav = (props: Props) => {

	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const employeeContext = useSelector<TcsmStates, EmployeeContext>(state => state.appContext.employeeContext);
	const role = useRoleObject();
	const location = useLocation();
	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);

	const navOptionItems = GenerateAdminQuickNavMenu(props.basePath, language, siteSettings);

	const navOptions = navOptionItems
		.filter(option => !option.employeeContext || option.employeeContext.includes(employeeContext))
		.filter(option => roleObjectMatch(option.rolesMatch, role) > 0);

	const pathName = location.pathname.toLocaleLowerCase();

	if (!navOptions.some(a =>
		(a.value?.length > 0 && pathName.includes((a.value?.toLocaleLowerCase()))) ||
		(a.fallbackMatch?.length > 0 && pathName.includes(a.fallbackMatch?.toLocaleLowerCase())))) {
		return null;
	}

	return (
		<DropdownNavigation options={navOptions} />
	);
};